import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({
    title: "Page not found",
    description: "We couldn't find the page you were looking for.",
    path: "/404",
  });
  return (
    <div
      data-testid="page-not-found"
      className="min-h-[60vh] flex items-center justify-center px-6"
    >
      <div className="text-center">
        <p className="tpc-eyebrow">Error 404</p>
        <h1 className="mt-4 font-serif text-5xl sm:text-6xl tracking-tight">
          We can’t find that page.
        </h1>
        <p className="mt-5 text-[#4A5348] max-w-md mx-auto">
          The link may be old, or the page may have moved. Let’s get you back
          on track.
        </p>
        <Link to="/" className="tpc-btn tpc-btn-primary mt-8 inline-flex">
          Return home
        </Link>
      </div>
    </div>
  );
}
